import React from 'react';
import Services from '../../api/service'

const ServiceSection = (props) => {

    return (
        <section className="service_section section_space xb-hidden pb-0">
            <div className="container">
                <div className="heading_block text-center">
                    <div className="heading_focus_text">
                        Our
                        <span className="badge bg-secondary text-white">Specialty</span>
                    </div>
                    <h2 className="heading_text mb-0">
                        Featured Services
                    </h2>
                </div>

                <div className="row">
                    {Services.slice(0, 5).map((service, srv) => (
                        <div className={`${service.col} mt-30`} key={srv}>
                            {service.title ?
                                <div className="service_block">
                                    <div className="service_image">
                                        <img src={service.sImg} alt="IT Management Services" />
                                    </div>
                                    <div className="service_content">
                                        <h3 className="service_title">
                                            <span style={{
                                                display: 'inline-block',
                                                color: '#1a1a1a',
                                                backgroundColor: 'rgba(255,255,255,0.9)',
                                                padding: '8px 12px',
                                                borderRadius: '8px'
                                            }}>{service.title}</span>
                                        </h3>

                                        <div className="links_wrapper">
                                            <ul className="category_btns_group unordered_list">
                                                <li><span style={{
                                                    color: '#1a1a1a',
                                                    backgroundColor: 'rgba(255,255,255,0.9)',
                                                    border: '1px solid rgba(255,255,255,0.3)',
                                                    padding: '6px 12px',
                                                    borderRadius: '4px',
                                                    display: 'inline-block'
                                                }}>{service.thumb1}</span></li>
                                                <li><span style={{
                                                    color: '#1a1a1a',
                                                    backgroundColor: 'rgba(255,255,255,0.9)',
                                                    border: '1px solid rgba(255,255,255,0.3)',
                                                    padding: '6px 12px',
                                                    borderRadius: '4px',
                                                    display: 'inline-block'
                                                }}>{service.thumb2}</span></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                : ''}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default ServiceSection;